(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Engagement"] && !Shopify.designMode) return;
  try {
    
  class EngagementsSlider {
    constructor(el) {
      this.section = el;
      this.grid = el.querySelector('.engagements__grid');
      this.cards = Array.from(el.querySelectorAll('.engagements__card'));
      this.dots = Array.from(el.querySelectorAll('.engagements__dot'));
      if (!this.grid || this.cards.length < 2) return;

      this.bindDots();
      this.observeCards();
      this.initDrag();
    }

    initDrag() {
      const slider = this.grid;
      let isDown = false;
      let startX = 0;
      let startScroll = 0;
      this.moved = false;

      const isScrollable = () => slider.scrollWidth > slider.clientWidth + 1;

      slider.addEventListener('pointerdown', (e) => {
        // Sur tactile, on laisse le scroll natif gerer (momentum + snap)
        if (e.pointerType === 'touch' || !isScrollable()) return;
        isDown = true;
        this.moved = false;
        startX = e.clientX;
        startScroll = slider.scrollLeft;
        slider.classList.add('is-dragging');
        slider.setPointerCapture(e.pointerId);
      });

      slider.addEventListener('pointermove', (e) => {
        if (!isDown) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 4) this.moved = true;
        slider.scrollLeft = startScroll - dx;
      });

      const stop = () => {
        if (!isDown) return;
        isDown = false;
        slider.classList.remove('is-dragging'); // reactive scroll-snap -> snap auto
      };

      slider.addEventListener('pointerup', stop);
      slider.addEventListener('pointercancel', stop);
      slider.addEventListener('pointerleave', stop);

      // Empeche le clic accidentel sur un lien apres un drag
      this.cards.forEach((card) => {
        card.querySelectorAll('a').forEach((a) => {
          a.addEventListener('click', (e) => {
            if (this.moved) {
              e.preventDefault();
              this.moved = false;
            }
          });
        });
      });
    }

    bindDots() {
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.target, 10);
          const card = this.cards[index];
          if (!card) return;
          this.grid.scrollTo({
            left: card.offsetLeft - this.grid.offsetLeft,
            behavior: 'smooth',
          });
        });
      });
    }

    setActive(index) {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    observeCards() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio > 0.55) {
              const index = parseInt(entry.target.dataset.index, 10);
              this.setActive(index);
            }
          });
        },
        { root: this.grid, threshold: [0.55] }
      );
      this.cards.forEach((card) => observer.observe(card));
    }
  }

  function initEngagements(scope) {
    (scope || document).querySelectorAll('.engagements').forEach((el) => {
      if (!el.dataset.engInit) {
        el.dataset.engInit = 'true';
        new EngagementsSlider(el);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => initEngagements());

  // Reinitialise dans l'editeur de theme quand la section est rechargee
  document.addEventListener('shopify:section:load', (event) => {
    initEngagements(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
